<template>
  <div class="page">
    <div class="form">
      <div class="cell-list">
        <!-- <div class="cell" @click="selectMethod"> -->
        <div class="cell">
          <div class="label">
            退货方式
            <span>*</span>
          </div>
          <div class="content">
            <span>{{ returnMethod.name }}</span>
            <!-- <van-icon class="arrow" name="arrow" /> -->
          </div>
        </div>
      </div>
      <div class="Audit-opinion">
        <p class="title">
          补充说明 <span style="color:red;font-family: PingFangSC-Regular;font-size: 14px;">*</span>
        </p>
        <van-field
            class="textarea"
            v-model="content"
            autosize
            type="textarea"
            maxlength="500"
            placeholder="请输入"
          />
        <div class="tip">{{ content.length }}/500</div>
      </div>
    </div>
    <!-- 弹框 -->
    <list
      ref="picker"
      @select="selectItem"
      @close="selectItem"
      :datalist="dataList"
      :header="'退货方式'"
    />
    <div class="btn-box">
      <div
        class="btn"
        :class="{'btn-disable': !content}"
        @click="confirm"
      >确定</div>
    </div>
    <!-- 不予受理 -->
    <!-- <div class="container">
      <div class="item line_bottom">
        <div class="left">
          <span>退货单号</span>
          <span>{{orderNumber}}</span>
        </div>
        <span>></span>
      </div>
      <div class="item line_bottom" @click="showType">
        <div class="left">
          <span>原由</span>
          <span class="result_style" :class="{'choosed':choose}">{{typeValue}}</span>
        </div>
        <img src="../../../../assets/image/right.png" class="back" />
      </div>
      <div class="result">
        <span class="info">补充</span>
        <textarea class="content" placeholder="请输入不予受理补充内容..." v-model="content"></textarea>
      </div>
      <div class="btn" v-if="isOriginHei">
        <span @click="confirm" :class="{'active':change}">确认</span>
      </div>
      <common-picker ref="commonPicker" :typeList="typeList" :cols="cols1" @getTypeValue="getTypeValue"></common-picker>
    </div>-->
  </div>
</template>
<script>
    import util from '../../../../utils/common';
    import api from '../../../../service/modules/refund';
    import { mapState, mapActions } from 'vuex';
    import { isMoment } from 'moment';
    import list from '../components/listPopup';
    import { Dialog } from 'vant';

    export default {
        computed: {
            ...mapState('refund', ['dictType'])
        },
        components: { list },
        data () {
            return {
                returnMethod: {}, // 所选退货方式
                content: '',
                dataList: [], // 退货方式列表
                finalRefundTypes: 0, // 退货方式
                flowId: 0
            };
        },
        watch: {
            // content: {
            //     handler (newValue, oldValue) {
            //         if (newValue.length === 100) {
            //             this.$Toast('字数不超过100!');
            //         }
            //     }
            // }
        },
        mounted () {
            window.onresize = () => {
                return (() => {
                    if (this.documentHeight > document.documentElement.clientHeight) {
                        this.isOriginHei = false;
                    } else {
                        this.isOriginHei = true;
                    }
                })();
            };
        },
        created () {
            try {
                this.finalRefundTypes = this.$route.query.finalRefundTypes;
                this.flowId = this.$route.query.flowId;
                api.getDictType().then(res => {
                    if (res.ret === 0 && res.data.SYS_REFUND_TYPES) {
                        res.data.SYS_REFUND_TYPES.map(item => {
                            if (item.code != this.finalRefundTypes) {
                                this.returnMethod = {
                                    name: item.name,
                                    id: item.code
                                };

                            }

                            this.dataList.push({
                                name: item.name,
                                id: item.code
                            });
                        });
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        methods: {
            ...mapActions('refund', ['setDictType']),
            // 打开退货方式弹框
            selectMethod () {
                this.$refs.picker.init(this.returnMethod);
            },
            selectItem (item) {
                this.returnMethod = item;
            },
            confirm () {
                if (!this.content) {
                    return this.$Toast({
                        message: '请填写补充说明'
                    });
                }
                if (this.finalRefundTypes == this.returnMethod.id) {
                    // return;
                }
                Dialog.confirm({
                    title: `是否变更为${this.returnMethod.name}`,
                    message: '变更后退货单将按照新退货方式流转',
                    confirmButtonText: '变更',
                    cancelButtonText: '取消',
                    confirmButtonColor: '#36B374',
                    className: 'setConfirm',
                    theme: 'round'
                }).then(() => {
                    api
                        .refundMethod1({
                            flowId: this.flowId,
                            refundType: this.returnMethod.id,
                            context: this.content
                        })
                        .then(res => {
                            if (res.ret === 0) {
                                this.$Toast({
                                    message: res.msg
                                });
                                setTimeout(() => {
                                    this.$router.back();
                                }, 1500);
                            } else {
                                // this.$Toast({
                                //     message: res.msg
                                // });
                            }
                        });
                });
            },
            getAccept1 () {
                // 变更退货方式
                api
                    .refundMethod1({
                        flowId: this.flowId,
                        refundType: this.code,
                        context: this.content
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.$Toast({
                                message: res.msg
                            });
                            this.isOriginHei = false;
                            setTimeout(() => {
                                this.$router.back();
                            }, 1500);
                        } else {
                            this.$Toast({
                                message: res.msg
                            });
                        }
                    });
            }
        }
    };
</script>
<style lang="less" scoped>
.page {
  padding-bottom: 90px;
  .van-icon-arrow:before {
    font-size: 12px;
  }
  .form {
    padding: 0 16px;
    .cell-list {
      margin-bottom: 24px;
      .cell {
        padding: 20px 0;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .label {
          font-size: 14px;
          color: #666666;
          span {
            vertical-align: middle;
            margin-left: 2px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #F94F4E;
          }
        }
        /deep/.content {
          display: flex;
          align-items:  center;
          .van-field__control {
            text-align: right;
          }
          // .van-radio__label {
          //   font-size: 14px;
          //   color: #171a1d;
          // }
          // .van-radio__icon {
          //   display: flex;
          //   align-items: center;
          // }
          span {
            font-size: 14px;
            color: #171a1d;
          }
          .arrow {
            font-size: 1px;
            margin-left: 5px;
          }
        }
      }
      .order-item {
        padding: 16px 16px 20px;
        background-color: #f7f7f7;
        border-radius: 4px;
        position: relative;
        margin-bottom: 12px;
        .title {
          font-size: 16px;
          color: #333333;
          font-weight: 400;
          margin-bottom: 10px;
        }
        .info {
          font-size: 12px;
          color: #999999;
          &:not(:last-child) {
            margin-bottom: 6px;
          }
        }
      }
    }
    .Audit-opinion {
      position: relative;
      .title {
        font-size: 14px;
        color: #666666;
        margin-bottom: 12px;
        margin-top: 20px;
      }
      /deep/.textarea {
        width: 100%;
        background: #f8f9fb;
        padding: 16px 4px 16px 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
        .van-field__control {
          min-height: 120px;
          max-height: 320px;
        }
         .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .tip {
        text-align: right;
        padding-right: 16px;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
    }
  }
  .btn-box {
    padding: 8px 16px 35px;
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    box-shadow: 0 0 16px 0 rgba(0,0,0,0.05);
    .btn {
      background-color: #37b375;
      padding: 16px 0;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      border-radius: 4px;
    }
    .btn-disable {
      opacity: 0.5;
    }
  }
  .returnOrder-pop {
    .body {
      padding: 0 16px;
      .header {
        padding-top: 20px;
        margin-bottom: 14px;
        font-size: 16px;
        color: #171a1d;
        font-weight: 600;
      }
      .vant-search {
        padding: 0;
        margin-bottom: 20px;
      }
      .order-list {
        max-height: 464px;
        overflow-y: auto;
        .order-item {
          padding: 16px 16px 20px;
          background-color: #f7f7f7;
          border-radius: 4px;
          position: relative;
          margin-bottom: 12px;
          .circle {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 1px solid #a3a4a7;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 16px;
          }
          .circle-active {
            width: 18px;
            height: 18px;
            padding: 3px;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 16px;
            border: 1px solid #36b374;
            p {
              border-radius: 50%;
              background-color: #36b374;
              width: 100%;
              height: 100%;
            }
          }
          .title {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
            margin-bottom: 10px;
          }
          .info {
            font-size: 12px;
            color: #999999;
            &:not(:last-child) {
              margin-bottom: 6px;
            }
          }
        }
      }
      .nodata {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 88px;
          height: 88px;
          margin-bottom: 18px;
          margin-top: 110px;
        }
        .p1 {
          font-size: 16px;
          color: #666666;
          font-weight: 400;
          margin-bottom: 11px;
        }
        .p2 {
          font-size: 12px;
          color: #999999;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
